/**
 * Extracts a user-friendly error message from an API error response.
 * Handles common response formats:
 * - { message: "..." }
 * - { detail: "..." }
 * - { error: "...", message: "..." }
 * - { fieldErrors: [...] }
 */
export function getErrorMessage(err, fallback = "Something went wrong") {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;

  // Primary: message field (Spring Boot style)
  if (data.message) return data.message;

  // Secondary: detail field (FastAPI style)
  if (data.detail) {
    if (typeof data.detail === "string") return data.detail;
    if (Array.isArray(data.detail)) return data.detail.map((e) => e.msg || JSON.stringify(e)).join(". ");
  }

  // Field errors
  if (data.fieldErrors && Array.isArray(data.fieldErrors)) {
    return data.fieldErrors.map((e) => `${e.field}: ${e.message}`).join(". ");
  }

  // Generic error field
  if (data.error && typeof data.error === "string" && !data.message) return data.error;

  return fallback;
}
